"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
function SvgComponent(props) {
    const { fill = 'none' } = props, restProps = __rest(props, ["fill"]);
    return (react_1.default.createElement("svg", Object.assign({ "aria-hidden": 'true', focusable: 'false', className: `fl-${fill}`, width: 24, height: 24, viewBox: '0 0 24 24', xmlns: 'http://www.w3.org/2000/svg' }, restProps),
        react_1.default.createElement("path", { fillRule: 'evenodd', clipRule: 'evenodd', d: 'M8.44365 5.46971C8.70989 5.20343 9.12655 5.17918 9.42018 5.39702L9.5043 5.46963L15.7071 11.6714C15.8629 11.8272 15.8634 12.0796 15.7081 12.236L9.46248 18.5284C9.17067 18.8223 8.6958 18.8241 8.40182 18.5323C8.13457 18.267 8.10881 17.8505 8.32557 17.556L8.39788 17.4716L13.5895 12.2398C13.7447 12.0835 13.7442 11.831 13.5884 11.6752L8.44373 6.53037C8.17744 6.26413 8.1532 5.84747 8.37103 5.55384L8.44365 5.46971Z' })));
}
exports.default = SvgComponent;
